import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Slug from '../../../components/slug/slug';

/*
 import { canUseDOM } from 'exenv';
 if(canUseDOM) {
 debugger;
 }
 */

// eslint-disable-next-line react/prefer-stateless-function
class Community extends Component {
  render() {
    /* eslint-disable jsx-a11y/iframe-has-title */
    return (
      <div>
        <section className="page-title">
          <Slug slugName="Fastco. Community" className="section-page" />
        </section>

        <iframe
          className="community-frame-test"
          width="100%"
          height="1500"
          scrolling="no"
          src="https://stagingv2.spot.im/embed/modules/topics/demo/index.html#/topic/sp_IjnMf2Jd/top_OmK1Ndpvn3A4"
        />
      </div>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    config: state.config || {}
  };
}

Community.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  config: PropTypes.shape({}).isRequired
};

export default withRouter(connect(mapStateToProps)(Community));



// WEBPACK FOOTER //
// ./src/views/containers/pages/community_page/community_page.js